/** Só `http:`/`https:` abre pelo selo; qualquer outro esquema (ou texto solto) não vira link. */
export function safeHttpUrl(value: string | null | undefined): string | null {
  const text = value?.trim();
  if (!text) return null;
  try {
    const { protocol } = new URL(text);
    return protocol === "http:" || protocol === "https:" ? text : null;
  } catch {
    return null;
  }
}
